<template>
    <span
        v-if="banderol"
        class="kgr-card__status"
        :class="banderolClass"
        :title="title"
        @mouseover="$emit('mouseover')"
        @mouseout="$emit('mouseout')"
    >
        <kgr-icon
            :icon-class="iconClass"
            inverted
            style="pointer-events: none"
        />
    </span>
    <span
        v-else
        :title="title"
        style="vertical-align: middle"
    >
        <kgr-icon
            :icon-class="iconClass"
            :style="{ color }"
        />
    </span>
</template>

<script>
import Icon from '../common/icon/Icon.vue';
import MemberContractState from '../../js/dto/MemberContractState';

export default {
    name: 'kgr-member-contract-state-icon',
    components: {
        'kgr-icon': Icon,
    },
    props: {
        state: {
            type: MemberContractState,
            required: true,
        },
        banderol: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
    computed: {
        title() {
            if (this.state.status === 3) {
                return this.$t(`memberContractState.${this.state.status}`);
            }
            return this.$t(`memberContractState.${this.state.contractType}.${this.state.status}`);
        },
        color() {
            if (this.state.contractType === 'regular') {
                return 'var(--kgr-card-status-green)';
            }
            if (this.state.contractType === 'guest') {
                return 'var(--kgr-card-status-yellow)';
            }
            if (this.state.contractType === 'passive') {
                return 'var(--kgr-card-status-blue)';
            }
            return '#cbcbcb';
        },
        banderolClass() {
            if (this.state.contractType === 'regular') {
                return 'kgr-card__status--green';
            }
            if (this.state.contractType === 'guest') {
                return 'kgr-card__status--yellow';
            }
            if (this.state.contractType === 'passive') {
                return 'kgr-card__status--blue';
            }

            return 'kgr-card__status--grey';
        },
        iconClass() {
            if (this.state.status === 1 && this.state.contractType === 'guest') { // guest
                return 'account';
            }
            if (this.state.status === 0) { // ended
                return 'door-exit';
            }
            if (this.state.status === 1) { // active
                return 'check';
            }
            if (this.state.status === 2) { // scheduled
                return 'door-enter';
            }

            return 'block';
        },
    },
};
</script>
